import { render, staticRenderFns } from "./GroupsPayments.vue?vue&type=template&id=361eacc3&scoped=true&"
import script from "./GroupsPayments.vue?vue&type=script&lang=ts&"
export * from "./GroupsPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361eacc3",
  null
  
)

export default component.exports